import React, { Component } from 'react'
import styles from './style.module.less'
import { observer } from 'mobx-react'

@observer
export default class extends Component {
  render() {
    return <div className={styles.wrapper}>点击左侧模块，即可编辑</div>
  }
}
